var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.668C16 14.563 12.866 13.668 9 13.668M16 15.668C16 16.773 12.866 17.668 9 17.668C5.134 17.668 2 16.773 2 15.668M16 15.668V20.605C16 21.744 12.866 22.668 9 22.668C5.134 22.668 2 21.745 2 20.605V15.668M16 15.668C19.824 15.668 23 14.681 23 13.668V3.66797M9 13.668C5.134 13.668 2 14.563 2 15.668M9 13.668C4.582 13.668 1 12.681 1 11.668V6.66797M9 4.66797C4.582 4.66797 1 5.56297 1 6.66797M1 6.66797C1 7.77297 4.582 8.66797 9 8.66797C9 9.68097 12.253 10.668 16.077 10.668C19.9 10.668 23 9.68097 23 8.66797M23 3.66797C23 2.56297 19.9 1.66797 16.077 1.66797C12.253 1.66797 9.154 2.56297 9.154 3.66797M23 3.66797C23 4.77297 19.9 5.66797 16.077 5.66797C12.254 5.66797 9.154 4.77297 9.154 3.66797M9.154 3.66797V13.834",
    stroke: "#727272",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.4569a602ca968f487ff6cb0c411d7330.svg";
export { ForwardRef as ReactComponent };